<template>
  <div class="confirm-page">
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
      :show-close="false"
      :before-close="handleClose"
    >
      <div class="content">
        <p class="success">
          <img src="../../../assets/images/success.png" alt="">
        </p>
        <p class="mainTitle">You have successfully deleted this Request, a confirmation mail has been sent out to you.
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          plain class="viewRequest"
          @click="viewOldRequest"
        >Back to My Requests</el-button>
      <el-button type="primary" @click="addNewRequest">Add New Request</el-button>
    </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'ConfirmPage',
  props: {
    dealId: String,
    businessEmail: String,
    shippingEmail: String,
    operatorContactEmail: String,
    showConfirm: Boolean,
    sendRentalRequestConfirmationMailToShippingContact: Boolean,
    sendRentalRequestConfirmationMailToOperator: Boolean
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  created () {
    this.dialogVisible = this.showConfirm
  },
  methods: {
    handleClose (print) {
      if (print === true) {
        this.$emit('closeConfirm', true)
      } else {
        this.$emit('closeConfirm', false)
      }
    },
    viewOldRequest () {
      this.$emit('showRequest')
    },
    addNewRequest () {
      this.$emit('addNewRequest', false)
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-dialog {
  background: #FFFFFF !important;
}

/deep/ .el-dialog__wrapper .el-dialog .el-dialog__header .el-dialog__headerbtn .el-icon-close:before {
  color: #555;
  font-weight: 600;
  font-size: 20px;
}

.content {
  color: #666666;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;

  p {
    line-height: 24px;
  }

  .fw {
    font-weight: 700;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .success {
    img {
      width: 48px;
      height: 48px;
    }
  }

  .mainTitle {
    font-weight: 700;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    margin-bottom: 20px;
  }

  .note {
    font-weight: 500;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 14px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
  }
}

.viewRequest {
  background: #fff;
  color: #33ab4f;
  margin-right: 20px;
  width: 160px;
  height: 40px;
}
</style>
